<template>
	<div class="fs" @click="fullscreen()">
		<fs-icon/>
	</div>
</template>

<script>
import FsIcon from './icons/fullscreen.svg'

export default {
	name: 'FullscreenControl',
	components: {
		FsIcon
	},
	methods: {
		fullscreen() {
			let elm = document.documentElement

			if (elm.requestFullscreen) {
				elm.requestFullscreen()
			}
			else if (elm.mozRequestFullScreen) {
				elm.mozRequestFullScreen()
			}
			else if (elm.webkitRequestFullScreen) {
				elm.webkitRequestFullScreen()
			}
		}
	}

}
</script>


<style scoped lang="scss">

.fs {
	@include base-circle() {
		background-color: #fff;
		width: 34px;
		height: 34px;
		padding: 8px;
		margin: 8px 6px;
		cursor: pointer;

		svg {
			> * {
				fill: $bg-box;
			}
		}
	}
}

</style>
